import { useRef } from 'react';
import { WordPrintInput } from './atom.input.js';
import { wrapper, heading } from './atom.task.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function WordPrintTask(props) {
  const ref = useRef(null);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: wrapper,
    children: [props.component.data.tasks.length > 0 && /*#__PURE__*/jsx("h2", {
      className: heading,
      children: props.task.title
    }), props.task.inputs.map(input => /*#__PURE__*/jsx(WordPrintInput, {
      taskId: props.task.id,
      input: input,
      entryKey: props.component.entryKey
    }, input.id))]
  });
}

export { WordPrintTask };
//# sourceMappingURL=atom.task.js.map
